/* constants */
import { MAP_PERFIL } from "@/constants/perfisGED"

class PerfilRegistroHelper {
  static getPerfilGED (livro) {
    const perfis = MAP_PERFIL.filter((item) => {
      return livro ? item.livro.indexOf(livro) > -1 : item
    })

    return perfis.map((item) => {
      return {
        id: item.id,
        desc: item.desc
      }
    })
  }
}

export default PerfilRegistroHelper
